import DashboardLayout from '../layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../pages/NotFoundPage.vue'

import { createRouter, createWebHistory } from 'vue-router'
import store from "../vuex/store.js";
import Cookies from "js-cookie";

// Admin pages
import Overview from '@/pages/Overview/Overview.vue'

//AUTH
import Register from '@/pages/Auth/Register.vue'
import RegisterRne from '@/pages/Auth/RegisterRne.vue'
import Recover from '@/pages/Auth/Recover.vue'
import Login from '@/pages/Auth/Login.vue'
import About from '@/pages/Auth/About.vue'

//PROFILE
import Profile from '@/pages/Profile/Edit.vue'

//Platform VIEW
import Platform from '@/pages/Platform/View.vue'

//POSTULATION
import Postulation from '@/pages/Postulation/List.vue'

//MY PAYMENTS
import MyPayments from '@/pages/MyPayments/List.vue'

//RNE
import RneView from '@/pages/Rne/View.vue'

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/recover',
    name: 'recover',
    component: Recover
  },
  {
    path: '/registro',
    name: 'register',
    component: Register
  },
  {
    path: '/registro-rne',
    name: 'register-rne',
    component: RegisterRne
  },
  {
    path: '/about',
    name: 'about',
    component: About
  },
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/overview',
    children: [
      {
        path: 'overview',
        name: 'Overview',
        component: Overview
      },
      {
        path: 'profile',
        name: 'Profile',
        component: Profile
      },
      {
        path: 'platform/:id',
        name: 'Platform',
        component: Platform
      },
      {
        path: 'postulation',
        name: 'Postulation',
        component: Postulation
      },
      {
        path: 'my-payments',
        name: 'MyPayments',
        component: MyPayments
      },
      {
        path: 'rne',
        name: 'RNE',
        component: RneView
      },
    ]
  },
  { 
    path: '/:pathMatch(.*)*', 
    name: 'NotFound',
    component: NotFound 
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "nav-item active"
})

router.beforeEach((to, from, next) => {
  const accessToken = Cookies.get("access_token");

  if (accessToken) {
    console.log("entro")
    console.log(to.name)
    if (to.name === "overview") {
      next("/overview");
      return;
    } else if (to.name === 'login') {
      next("/overview");
      return;
    } else if (to.name === 'recover') {
      next("/overview");
      return;
    } else if (to.name === 'register') {
      next("/overview");
      return;
    } else if (to.name === 'register-rne') {
      next("/overview");
      return;
    }

    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

    const isLoggedIn = store.state.status;

    if (requiresAuth && !isLoggedIn) {
      alert('Por favor inicie sesión para continuar');
      next("/login");
      return;
    }

    } else if (to.name !== 'login' && to.name !== 'recover' && to.name !== 'register' && to.name !== 'register-rne' && to.name !== 'about') {
      console.log("redirecciona a login", to)
      
      next("/login");
      return;
    } 
    console.log("no necesita login", to)
    next();
});

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default router
